import { forwardRef } from "react";
import { PhraseText, SoundVisualizerRef } from "../../types";
import { Box, Center, Text, useTheme } from "@chakra-ui/react";
import { WaveSoundVisualizer } from "../atoms/WaveSoundVisualizer";
import { CALIBRATION_MIN_LOG_POWER } from "../../constants";
import { decibelToVolume } from "../../utils/calcVolume";

type PhraseVisualizerProps = {
  currentPhrase: PhraseText;
  showThreshold?: boolean;
  isRecording?: boolean;
};
export const PhraseWaveSoundVisualizer = forwardRef<
  SoundVisualizerRef,
  PhraseVisualizerProps
>((props, ref) => {
  const theme = useTheme();
  const underThreshold = decibelToVolume(CALIBRATION_MIN_LOG_POWER);
  return (
    <Box
      minHeight={{
        base: "320px",
        sm: "490px",
      }}
      width="100%"
      mt={2}
    >
      <WaveSoundVisualizer
        ref={ref}
        upperThreshold={0.81}
        underThreshold={underThreshold}
        maxValue={1}
        height="70px"
        width="100%"
        isRecording={props.isRecording}
        currentPhrase={props.currentPhrase}
      />
      <Center w="full" flexDirection="column" gap={2} mt={5}>
        <Text
          maxWidth="100%"
          fontSize={{
            base: "2xl",
            sm: "4xl",
          }}
          textAlign="center"
          whiteSpace="pre-wrap"
          color="primary.theme_lv1"
          fontWeight={900}
          lineHeight={1.2}
          width="100%"
          height={{
            base: "170px",
            sm: "350px",
          }}
          display="flex"
          justifyContent="center"
          alignItems="center"
          borderWidth="2px"
          borderStyle="solid"
          borderColor={theme.colors.primary["theme_lv1"]}
          bg={theme.colors.common["base"]}
        >
          {props.currentPhrase.phrase}
        </Text>
        <Text
          maxWidth="300px"
          textAlign="center"
          whiteSpace="pre-wrap"
          fontSize={{
            base: "xl",
            sm: "3xl",
          }}
          mt={2}
        >
          {props.currentPhrase.helperText || ""}
        </Text>
      </Center>
    </Box>
  );
});
PhraseWaveSoundVisualizer.displayName = "PhraseVisualizer";
